/* import __COLOCATED_TEMPLATE__ from './fly-responsive-tabs.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
/**
  FlyResponsiveTabs is a wrapper for `fly-nav-tab` that displays tabs that size 
  accordingly based on the container size. A toggle for a dropdown menu is 
  shown on the right that displays every single tab as a list item (unless disabled).

  ```hbs
  <FlyResponsiveTabs
    \@onAddTab={{this.onAddTab}}
    \@tabItems={{this.tabItems}}
  />
  ```

  @class FlyResponsiveTabs
  @public
 */
let FlyResponsiveTabs = (_class = class FlyResponsiveTabs extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isTabDropdownFocused", _descriptor, this);
  }
  get filteredTabItems() {
    if (this.args.visibleTabCount != null) {
      return this.args.tabItems.slice(0, this.args.visibleTabCount);
    }
    return this.args.tabItems;
  }
  get tabCount() {
    return this.args.tabItems?.length ?? 0;
  }
  get isDropdownShown() {
    return this.args.hideDropdown !== true && this.tabCount > 0;
  }
  onTabDropdownMouseEvent() {
    this.isTabDropdownFocused = !this.isTabDropdownFocused;
  }
  openOverflowDropdown(openPopover) {
    this.args.onClickDropdown?.();
    openPopover();
  }
  handleTabClick(tab) {
    this.args.onTabClick?.(tab);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isTabDropdownFocused", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "onTabDropdownMouseEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTabDropdownMouseEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openOverflowDropdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openOverflowDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTabClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTabClick"), _class.prototype)), _class);
export { FlyResponsiveTabs as default };